import {
  getRequiredFeatures,
  hasAutoInstrumentation,
  hasLoadPublicFunctions,
  hasKey,
} from '../state/init';
import { globalScope } from '../window/browser';
import { FEATURE_NAMES } from '../features/constants';

export class Instrument {
  constructor(aggregator, featureName) {
    this.aggregator = aggregator;
    this.featureName = featureName;

    this.module = null;
    this.events = null;

    this.auto = hasAutoInstrumentation(featureName);
    this.loadFunctions = hasLoadPublicFunctions(featureName);
    this.requiredFeatures = getRequiredFeatures(featureName) ?? [];
    this.hasKey = hasKey(featureName);
    this.executeRequiredFeatures();
  }

  getAggregator() {
    return this.aggregator;
  }

  executeRequiredFeatures() {
    const requires = {
      [FEATURE_NAMES.sessionTrace]: globalScope?.WMANS?.session_trace?.send,
    };

    // eslint-disable-next-line no-restricted-syntax
    for (const required of this.requiredFeatures) {
      if (requires[required]) {
        requires[required]();
      }
    }
  }
}
